<template
>
    <v-card flat>
        <v-toolbar dense color="bal-gray">
            <v-toolbar-title>{{
                    $route.params.onboardingId === "new" ? "Add new" : activeOnboarding.name
                }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="handleSaveClick" dark color="bal-red">
                <v-icon>done</v-icon>
                {{ "Save" | t }}
            </v-btn>
            <v-btn @click="closeDrawer()" icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" background-color="bal-gray" color="bal-red">
            <v-tab v-for="item in tabs" :key="item" style="text-transform: none !important;">
                {{ item | t }}
            </v-tab>
            <v-tab-item>
                <general-info-edit-tab />
            </v-tab-item>
        </v-tabs>
    </v-card>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import GeneralInfoEditTab from "./tabs/general-info-edit-tab";

export default {
    name: "onboarding-admin-view",
    components: {GeneralInfoEditTab},
    data() {
        return {
            tab: 0,
            tabs: ["General info"]
        };
    },
    computed: {
        ...mapState('onboarding', ['activeOnboarding', 'loadingOnboardingData'])
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        await this.getOnboardingData(this.$route.params.onboardingId)

        if (this.$route.params.tab) {
            this.tab = this.tabs.indexOf(this.$route.params.tab);
        }
    },
    destroyed() {
        document.removeEventListener("keydown", this.handleKeyboardListener);
    },
    methods: {
        ...mapActions('onboarding', ['getOnboardingData', 'updateOnboardingData']),
        ...mapMutations('onboarding', ['setLoadingOnboardingData']),
        ...mapMutations(['setRequestSuccess', 'setRequestError', 'setErrorMessage']),
        closeDrawer() {
            this.$router.push({name: "onboarding-admin-list"});
        },
        handleKeyboardListener(e) {
            if (e.keyCode === 83 && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                this.submitEdit();
            }
            if (document.activeElement.tagName !== "INPUT" && document.activeElement.tagName !== "TEXTAREA") {
                if (e.key === "ArrowLeft") {
                    if (this.tab > 0) {
                        this.tab -= 1;
                    }
                } else if (e.key === "ArrowRight") {
                    if (this.tab + 1 < this.tabs.length) {
                        this.tab += 1;
                    }
                }
            }
        },
        async handleSaveClick() {
            if (!this.activeOnboarding) {
                return;
            }

            const response = await this.updateOnboardingData()
            this.setLoadingOnboardingData(false)
            if (response && response.data && response.data.success === 1) {
                await this.$router.push({
                    name: "onboarding-admin-view",
                    params: { companyId: response.data.id, tab: this.tabs[this.tab] }
                });
                this.setRequestSuccess(true);
            } else {
                this.setRequestError(true);
                this.setErrorMessage("Failed");
            }
        }
    }
};
</script>

<style scoped></style>
